import React from 'react';
import { ModalContent } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography, ModalContentAction } from 'common/components';
import { KITCHEN_SIGN_UP_HREF, KITCHEN_ELEMENT_BLOCK } from '../../../../../kitchen-constants';

type FreeKitchenProjectModalProps = {
  regionId: string;
};

export const FreeKitchenProjectModal = ({ regionId }: FreeKitchenProjectModalProps) => (
  <>
    <ModalHeader title="Бесплатный дизайн-проект" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Запишитесь на&nbsp;бесплатное проектирование, и&nbsp;мы&nbsp;поможем создать проект кухни под вашу
        планировку. Наши специалисты работают в&nbsp;магазине и&nbsp;онлайн. А&nbsp;если вы&nbsp;хотите
        рассчитать примерную стоимость кухни, воспользуйтесь нашим онлайн-калькулятором.
      </Typography>
      <ModalContentAction>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={KITCHEN_ELEMENT_BLOCK}
          elementName="Бесплатный дизайн-проект / modal"
          elementText="Записаться"
          href={`${KITCHEN_SIGN_UP_HREF}${regionId}`}
          target="_blank"
          wide>
          Записаться
        </ButtonWithGAClickButton>
      </ModalContentAction>
    </ModalContent>
  </>
);
